import { FC } from "react";
import { Stack, TextField } from "@mui/material";
import { OrganizationErrors, OrganizationInfo } from "../../api/organizations";

type Props = {
	value: OrganizationInfo;
	onChange: (value: OrganizationInfo) => void;
	errors?: OrganizationErrors;
};

/**
 * Editable organization details (name, address, phone, website).
 * Shared by the admin "Add New" dialog and the signup page.
 */
export const OrganizationFields: FC<Props> = ({ value, onChange, errors = {} }) => {
	const field = (key: keyof OrganizationInfo) => ({
		value: value[key],
		onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
			onChange({ ...value, [key]: e.target.value }),
		error: Boolean(errors[key]?.length),
		helperText: errors[key]?.[0],
		fullWidth: true,
	});

	return (
		<Stack gap="16px" sx={{ pt: "8px" }}>
			<TextField label="Organization name" required {...field("name")} />
			<TextField label="Address" multiline minRows={2} {...field("address")} />
			<Stack direction="row" gap="16px">
				<TextField label="Phone" type="tel" {...field("phone")} />
				<TextField label="Website" placeholder="www.example.com" {...field("url")} />
			</Stack>
		</Stack>
	);
};
